import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_INVENTORY_STATUS } from '@/configs/ecom/apis';

export const inventoryStatus = async (body: {
  productIds: string[];
  pinCode: string;
}): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_INVENTORY_STATUS), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
